import { ReportError } from "../connection/errors";
import StackTrace from "stacktrace-js";

let lastError = "";
let token = "";
let shouldHandle = true;

function sendErrorReport(err: any, msg: any) {
	//will throw on staging AND in production
	if (window.location.hostname.includes('brandnot.live') || window.location.hostname.includes('brandlive.com'))
		ReportError(token, navigator.userAgent, err, msg).catch(e =>
			console.error(e)
		);
}

function handleException(msg: any, file: any, line: any, col: any, error: any) {
	if (!shouldHandle) throw new Error(undefined);

	/*
		Handle cases where !error which means we can't stack trace below and also
		handle benign ResizeObserver errors when cannot deliver all observations 
		within single animation frame
		https://github.com/DevExpress/testcafe/issues/4857#issuecomment-598775956
	*/
	if (
		!error ||
		msg === 'ResizeObserver loop completed with undelivered notifications.' ||
		msg === 'ResizeObserver loop limit exceeded'
	) {
		return;
	}

	StackTrace.fromError(error)
		.then(err => {
			console.error(err);

			//dont double log errors
			if (lastError === msg) return;

			sendErrorReport(err, msg);

			lastError = msg;
		})
		.catch(e => {
			console.error(e);
		});
}

export function blockErrorHandling() {
	shouldHandle = false;
}

export function setErrorToken(userToken: string) {
	token = userToken;
}

export function setupErrorHandling() {
	window.onerror = (...args) => handleException(...args);
	Object.freeze(window.onerror);
}
